<template>
    <v-text-field :model-value="resolvedValue" :label="$t('text.email')" :rules="emailRules" required
        autocomplete="username" variant="outlined" density="compact" validate-on="blur" :loading="validationLoading"
        class="my-3" @update:modelValue="emitValue">
    </v-text-field>
</template>


<script>
export default {
    name: 'EmailField',
    emits: ['update:modelValue', 'input'],
    props: {
        modelValue: String,
        value: String,
        loading: Boolean,

    },
    components: {},

    data() {
        return {
            validationLoading: false,
            emailRules: [
                (v) => !!v || "E-mail is required",
                (v) =>
                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) ||
                    "E-mail must be valid",
            ],
        };
    },

    methods: {
        emitValue(value) {
            this.$emit('update:modelValue', value);
            this.$emit('input', value);
        }
    },

    computed: {
        resolvedValue() {
            return this.modelValue ?? this.value ?? '';
        }
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>